// @core/api/endpoints/form/publish_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormResponse,
  PublishFormRequest,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Publish form
 * Publishes a draft form, making it live and available for submissions.
 */
export async function PublishForm(
  form_id: string,
  data: PublishFormRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/publish`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.post<FormResponse>(requestPath, data, requestOptions);
}
